import { useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { ProfileContext } from "../contexts/profileContext";
import { OrgSpecialJobTitles } from "../components/admin/organization";

export default function SpecialJobTitles() {
  const [profile] = useContext(ProfileContext);
  const [org, setOrg] = useState(null);

  const { orgId } = useParams();
  const { organizations } = profile;

  useEffect(() => {
    if (!orgId || !organizations?.length) return;
    const org = organizations.find((org) => org._id === orgId);
    if (!org) return;
    setOrg({ ...org });
  }, [orgId, organizations]);

  if (!org?._id) return <div>Loading...</div>;

  return (
    <div className="h-screen overflow-y-auto pb-20">
      <h2 className="text-xl leading-10 font-bold mb-10">Special Job Titles</h2>
      <OrgSpecialJobTitles org={org} />
    </div>
  );
}
